import React from "react";
import { createContext } from "react";
export function useFinanceDrawerContext() {
    const context = React.useContext(FinanceDrawerContext);
    return context;
}
export const FinanceDrawerContext = /*#__PURE__*/ createContext(undefined);
